import react, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import {
  DataGrid,
  GridColDef,
  GridToolbarColumnsButton,
  GridToolbarContainer,
  GridToolbarDensitySelector,
  GridToolbarExport,
  GridToolbarFilterButton,
  GridValueGetterParams,
} from "@mui/x-data-grid";
import {useNavigate} from "react-router-dom";
import styled from "styled-components";
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import ThumbDownIcon from '@mui/icons-material/ThumbDown';
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { CloseOutlined } from "@mui/icons-material";
import DriveFolderUploadIcon from '@mui/icons-material/DriveFolderUpload';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
// import { TABS, ROLES, DATE_FORMATS } from "../../constants";
import Drawer from "../../components/common/drawer/drawer";
import { Dialog, DialogActions, DialogContent, DialogTitle, TextField, Typography, Modal, Button, Checkbox, Fab, IconButton, Stack, MenuItem, Select, InputLabel, FormControl, Paper, Tabs, Tab } from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import { ERROR_COLOR } from "../../constants";
import { Add, Save, SaveAlt } from "@mui/icons-material";
import OpaqueLoading from "../../components/opaqueLoading/opaqueLoading";
import DriveFileRenameOutlineIcon from '@mui/icons-material/DriveFileRenameOutline';
import DeleteIcon from '@mui/icons-material/Delete';
import ProductModal from "../../components/modals/productModal";
import BulkProductAdd from "../../components/modals/bulkProductAdd";
import SpecimenModal from "../../components/modals/specimenModal";
import SpecimenLineItemsModal from "../../components/modals/specimenLineItemsModal"
import searchIcon from "../../icons/searchIcon.svg"
import SpecimenAllotmentModal from "../../components/modals/SpecimenAllotmentModal";
import { set } from "date-fns";
import BulkUploadTargetUser from "../../components/modals/bulkUploadTargetUser";
import BulkUploadSpecimenByAdmin from "../../components/modals/BulkUploadSpecimenByAdmin";

const isMobile = window.innerWidth < 900;

const StaffEditorPageContainer = styled.div`
  height: ${isMobile ? `auto` : `calc(100vh - 105px)`};
  width: 100%;
  background-color: white;
  padding: 10px 15px;
  ${isMobile &&
  `
      position: relative;
  
      `}
`;
const StyledTabs = styled(Tabs)(({ theme }) => ({
  borderRadius: '8px',
  '& .MuiTabs-indicator': {

    height: '3px',
    borderRadius: '3px',
  },
}));
const StyledTab = styled(Tab)(({ theme }) => ({
  fontWeight: 600,
  fontSize: '15px',
  color: '#555',
  textTransform: 'none',
  '&.Mui-selected': {
    color: "#d6e0f5",
  },
}));
const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: ${isMobile ? "flex-start" : "space-between"};
  margin-bottom: 10px;
  flex-direction: ${isMobile ? "column" : "row"};
`;

const HeaderButtonsContainer = styled.div`
  ${isMobile && "margin-top:10px;"}
`;

const TableContainer = styled.div`
  // height: calc(
  //   100vh - ${isMobile ? "56px - 20px - 82.23px" : "100px - 20px - 43.77px"}
  // );
  width: 100%;
  // border: solid 1px lightGrey;
  border-radius: 8px;
`;
const AvatarContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const DataGridContainer = styled.div`
  max-width: 100%; /* Add this line to limit the width */
  margin: 0 auto; /* Center the content horizontally */
  height: calc(100% );
  width: 100%;
  border: solid 1px lightGrey;
  border-radius: 8px;
  display: ${isMobile ? 'flex' : 'grid'};

  ${isMobile &&
  `
    flex-direction: column;
  `}
`;

const LoadingContainer = styled.div`
  height: calc(100% - 49px);
  display: flex;
  justify-content: center;
  align-items: center;
`;

const TabsContainer = styled.div`
  ${isMobile &&
  `
    height: calc(100vh - 56px - 20px);
  `}
`;

const GenerateReportButton = styled(Button)`
  margin-right: 10px !important;
`;
const BulkChangePinCodeButton = styled(Button)`
  margin-right: 10px !important;
`;

const PinCodeChangeButtonContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const FabStyle = styled(Fab)`
  && {
    z-index: 1};
  }
`;

const StyledHeader = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export default function SpecimenManagement() {
  const label = { inputProps: { "aria-label": "Checkbox demo" } };
  const [selectedTab, setSelectedTab] = useState(0);
  const [loading, setLoading] = useState(false);
  const [accessChanges, setAccessChanges] = useState("");
  const [showWarehouseFormModal, setShowWarehouseFormModal] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [paginationModel, setPaginationModel] = useState({ page: currentPage - 1, pageSize: 20, });
  const [visitModal, setVisitModal] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [dataModal, setDataModal] = useState();
  const [bulk, setBulk] = useState(false);
  const [newOrderStatus, setNewOrderStatus] = useState(0);
  const [allotedStatus, setAllotedStatus] = useState(0);
  const [rm, setRm] = useState("")
  const [rsm, setRsm] = useState("")
  const [asm, setAsm] = useState("")
  const [rsms, setRsms] = useState([]);
  const [deliveredSpecimens, setDeliveredSpecimens] = useState([]);
  const [allUsers, setAllUsers] = useState([]);
  const [asms, setAsms] = useState([]);
  const [rms, setRms] = useState([]);
  const [userData, setUserData] = useState(JSON.parse(localStorage.getItem('storedUserData')).user)
  const [startDate, setStartDate] = useState()
  const [endDate, setEndDate] = useState()
  const [rowCount, setRowCount] = useState()
  const [rejectData, setRejectData] = useState(null);
  const [reason, setReason] = useState("");
  const [openDialog, setOpenDialog] = useState(false);
  const [modal, setModal] = useState(false);
  const [modalData, setModalData] = useState();
  const [hasSearched, setHasSearched] = useState(false);
  const [specimenAllotmentModalOpen, setSpecimenAllotmentModalOpen] = useState(false);
  const [myAllotedSpecimeArr, setMyAllotedSpecimeArr] = useState([]);
  const [allSpecimensAllotedArr3, setAllSpecimensAllotedArr3] = useState([]);
  const [mySpecimenModalOpen, setMySpecimenModalOpen] = useState(false);
  const [quantityMySpecimenModal, setQuantityMySpecimenModal] = useState(null);
  const [reasonMySpecimenModal, setReasonMySpecimenModal] = useState("");
  const [selectedApprovalStatus, setSelectedApprovalStatus] = useState(null);
  const [selectedMySpecimenData, setSelectedMySpecimenData] = useState(null);
  const [newQuantityAsRemark, setNewQuantityAsRemark] = useState("");
  const [getDeliveredSpecimenModalData, setGetDeliveredSpecimenModalData] = useState(null);
  const [openGetDeliveredSpecimenViewModal, setOpenGetDeliveredSpecimenViewModal] = useState(false);
  const [getMyAllotSpecimensColumnsModalData, setGetMyAllotSpecimensColumnsModalData] = useState(null);
  const [openGetMyAllotSpecimensColumnsViewModal, setOpenGetMyAllotSpecimensColumnsViewModal] = useState(false);
  const [getAllSpecimensAllotedColumnsModalData, setGetAllSpecimensAllotedColumnsColumnsModalData] = useState(null);
  const [openGetAllSpecimensAllotedColumnsViewModal, setOpenGetAllSpecimensAllotedColumnsViewModal] = useState(false);
        const [accessModulesData, setAccessModulesData] = useState([]);

        const navigate = useNavigate();

  const formatDateTime = (inputDateString) => {
    const inputDate = new Date(inputDateString);

    // Check if the input date is valid
    if (isNaN(inputDate.getTime())) {
      return 'Invalid Date';
    }

    // Extract date and time components
    const year = inputDate.getUTCFullYear();
    const month = String(inputDate.getUTCMonth() + 1).padStart(2, '0');
    const day = String(inputDate.getUTCDate()).padStart(2, '0');
    const hours = String(inputDate.getUTCHours()).padStart(2, '0');
    const minutes = String(inputDate.getUTCMinutes()).padStart(2, '0');
    const seconds = String(inputDate.getUTCSeconds()).padStart(2, '0');

    // Format the date string without 'T' and 'Z'
    const formattedDateString = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;

    return formattedDateString;

  }

  const handleDelete = async (data) => {
    const isConfirmed = window.confirm("Are you sure you want to delete this specimen?");

    if (!isConfirmed) {
      return;
    }

    try {
      setLoading(true);
      let results = await window.Platform.database.deleteSpecimen({ id: data });
      setLoading(false);

      window.NotificationUtils.showSuccess("Specimen deleted successfully!");
      // getSpecimen();
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (selectedTab == 0) {
      if (hasSearched) {
        getSpecimen()
      }
    }
    else if (selectedTab == 1) {
      if (hasSearched) {
        getAllotSpecimens()
      }
    }
    else if (selectedTab == 3) {
      if (hasSearched) {
        getAllSpecimensAlloted()
      }
    }
    else if (selectedTab == 2) {
      if (hasSearched) {
        getMyAllotSpecimens()
      }
    }
  }, [paginationModel.page, newOrderStatus, paginationModel.pageSize]);

  // useEffect(() => {
  //   if (selectedTab == 0) {
  //     getSpecimen();
  //   }
  //   else if (selectedTab == 1) {
  //     getAllotSpecimens();
  //   }
  //   else if (selectedTab == 3) {
  //     getAllSpecimensAlloted()
  //   }
  //   else if (selectedTab == 2) {
  //     getMyAllotSpecimens()
  //   }
  // }, [selectedTab])
  
    useEffect(() => {
      // setDataGrid([]);
      setAccessChanges("");
      setPaginationModel({ page: 0, pageSize: 20, })
      setRsm("");
      setAsm("");
      setRm("");
      // setRowCount(0);
    //     if (selectedTab == 0) {
    //   getSpecimen();
    // }
    // else if (selectedTab == 1) {
    //   getAllotSpecimens();
    // }
    // else if (selectedTab == 3) {
    //   getAllSpecimensAlloted()
    // }
    // else if (selectedTab == 2) {
    //   getMyAllotSpecimens()
    // }
    }, [selectedTab]);
  

  const fetchTest = async () => {
    let results1 = await window.Platform.database.testApi();
  }

  const getSpecimen = async () => {
    try {
      setLoading(true);
      let payload = {
        pageNumber: paginationModel.page,
        recordPerPage: paginationModel.pageSize,
        status: newOrderStatus,
        // startDate: startDate,
        // endDate: endDate,
        ownerId: rm,
        // rsm: rsm,
        // asm: asm
        asm: userData?.role == 'asm' ? userData?.id : asm,
        rsm: userData?.role == 'rsm' ? userData?.id : rsm,
      }
      let results = await window.Platform.database.getAllSpecimens(payload);
      setRowCount(results?.data1)
      // console.log("results", results);
      // if(auth?.user?.role === ROLES.ADMIN){
      const jsonArrayWithId = results?.data?.map((obj, index) => ({ ...obj, id: index + 1 }));

      setAccessChanges(jsonArrayWithId);
      // }
      // setVisibleEmployees(results);
      // setLoading(false);
    } catch (error) {
      console.error("ERRORCHECK", error);
      window.NotificationUtils.showError("Error Fetching Data");
      // setLoading(false);
    }
    finally {
      setLoading(false)
    }
  }

  const getAllotSpecimens = async () => {
    try {
      setLoading(true);
      let payload = {
        pageNumber: paginationModel.page,
        recordPerPage: paginationModel.pageSize,
        status: allotedStatus,
        ownerId: rm,
        asm: userData?.role == 'asm' ? userData?.id : asm,
        rsm: userData?.role == 'rsm' ? userData?.id : rsm,
      }
      let results = await window.Platform.database.getAllotSpecimens(payload);
      setRowCount(results?.data1)
      console.log("results", results);
      const jsonArrayWithId = results?.data?.map((obj, index) => ({ ...obj, id: index + 1 }));
      setDeliveredSpecimens(jsonArrayWithId);
    } catch (error) {
      console.error("ERRORCHECK", error);
      window.NotificationUtils.showError("Error Fetching Data");
      // setLoading(false);
    }
    finally {
      setLoading(false)
    }
  }

  const getMyAllotSpecimens = async () => {
    try {
      setLoading(true);
      let payload = {
        pageNumber: paginationModel.page,
        recordPerPage: paginationModel.pageSize,
        status: allotedStatus,
        ownerId: rm,
        asm: userData?.role == 'asm' ? userData?.id : asm,
        rsm: userData?.role == 'rsm' ? userData?.id : rsm,
      }
      let results = await window.Platform.database.getMyAllotSpecimens(payload);
      setRowCount(results?.data1);
      const jsonArrayWithId = results?.data?.map((obj, index) => ({ ...obj, idIndex: index + 1 }));
      setMyAllotedSpecimeArr(jsonArrayWithId);
    } catch (error) {
      console.error("ERRORCHECK", error);
      window.NotificationUtils.showError("Error Fetching Data");
      // setLoading(false);
    }
    finally {
      setLoading(false)
    }
  }

  const getAllSpecimensAlloted = async () => {
    try {
      setLoading(true);
      let payload = {
        pageNumber: paginationModel.page,
        recordPerPage: paginationModel.pageSize,
        status: allotedStatus,
        ownerId: rm,
        asm: userData?.role == 'asm' ? userData?.id : asm,
        rsm: userData?.role == 'rsm' ? userData?.id : rsm,
      }
      let results = await window.Platform.database.getMyAcceptedAllotSpecimens(payload);
      setRowCount(results?.data1);
      // let results = await window.Platform.database.getAllSpecimensAlloted(payload);
      console.log("results", results);
      const jsonArrayWithId = results?.data?.map((obj, index) => ({ ...obj, id: index + 1 }));
      setAllSpecimensAllotedArr3(jsonArrayWithId);
    } catch (error) {
      console.error("ERRORCHECK", error);
      window.NotificationUtils.showError("Error Fetching Data");
      // setLoading(false);
    }
    finally {
      setLoading(false)
    }
  }

  const clearFilters = async () => {
    setLoading(true);
    setStartDate("")
    setEndDate("")
    setNewOrderStatus(0)
    setRm("")
    setRsm("")
    setAsm("")
    setPaginationModel((prev) => ({ ...prev, pageSize: 20 }))
    try {
      let data1 = {
        pageNumber: paginationModel.page,
        ownerName: "",
        status: 0
      }
      let results = await window.Platform.database.getAllSpecimens(data1);
      const jsonArrayWithId = results?.data?.map((obj, index) => ({ ...obj, id: index + 1 }));
      setRowCount(results?.data1)
      setAccessChanges(jsonArrayWithId);
    } catch (error) {
      console.error(error);
      window.NotificationUtils.showError("Error Fetching Data");
      setLoading(false);
    }
    finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchAccessModules();
    if (userData?.role.toLowerCase().includes('admin')) {
      getAllUsers()
    }
    if (userData?.role == 'rsm') {
      getUsers('rsm', userData?.id)
    }
    if (userData?.role == 'asm') {
      getUsers('asm', userData?.id)
    }
  }, [])

  async function getAllUsers() {
    let results = await window.Platform.database.fetchEmployees()
    if (results?.status) {
      window.NotificationUtils.showError(results.message);
      setLoading(false);
      return;
    }
    else {
      setAllUsers(results?.data)
      setRsms(results?.data?.filter((ele) => ele.role.toLowerCase() == 'rsm'))
      setRms(results?.data?.filter((ele) => ele.role.toLowerCase() == 'se'))
      setAsms(results?.data?.filter((ele) => ele.role.toLowerCase() == 'asm'))
      setLoading(false);
    }
  }

  async function getUsers(role, id) {
    if (id != "") {
      let results = await window.Platform.database.getUsersBasedOnManager({ userId: id })
      if (role == 'rsm') {
        setAsms(results?.data)
        setRms(results?.data1)
      }
      if (role == 'asm') {
        setRms(results?.data)
      }
    } else {
      if (role == 'rsm') {
        setRm("")
        setAsm("")
        setRms(allUsers?.filter((ele) => ele.role == 'se'))
        setAsms(allUsers?.filter((ele) => ele.role == 'asm'))
      }
      if (role == 'asm') {
        setRm("")
        setRms(allUsers?.filter((ele) => ele.role == 'se'))
      }
    }

  }

  const handleReject = (data) => {
    setRejectData(data);
    setOpenDialog(true);
  };

  const handleTabChange = async (value) => {
    setSelectedTab(value);
  };

  const handleConfirmReject = () => {
    if (reason.trim() === "") {
      window.NotificationUtils.showError("Remark is required to reject the order.")
      return;
    }
    approveRejectOrder({ ...rejectData, approvalStatus: "2", reason });
    setOpenDialog(false);
    setReason("");
    setRejectData(null);
  };

  const approveRejectOrder = async (val) => {
    // val["ownerId"] = userData.id
    // return;
    try {
      setLoading(true)
      const results = await window.Platform.database.approveRejectSpecimenToUser(val)
      if (results?.status) {
        window.NotificationUtils.showError("Something Went Wrong!")
        setLoading(false);
      }
      else {
        window.NotificationUtils.showSuccess("Specimen Approved Successfully");
        setLoading(false)
        getSpecimen()
      }
    }
    catch (err) {
      console.log(err)
      window.NotificationUtils.showError("Something Went Wrong!")
      setLoading(false)

    }
  }

      const fetchAccessModules = async () => {
        try {
            setLoading(true);
            let data = {
                pageNumber: paginationModel.page,
                recordPerPage: paginationModel.pageSize,
                userId : userData?.id,
                moduleId : "1iK1kZyMFB"
            }
            let results = await window.Platform.database.fetchAccessModules(data);
            if (results?.status) {
                window.NotificationUtils.showError(results?.message || "Something went wrong");
                setLoading(false);
                return;
            }
            else {
                const jsonArrayWithId = results?.data?.map((obj, index) => ({ ...obj, idIndex: index + 1 }));
                setAccessModulesData(jsonArrayWithId);
            }
        } catch (error) {
            console.error(error);
        }
        finally {
            setLoading(false)
        }
    }

  const handleOkMySpecimen = async () => {
    if (!newQuantityAsRemark || newQuantityAsRemark == "") {
      return window.alert("Accept Quantity is required");
    }
    if (selectedMySpecimenData?.quantity <= newQuantityAsRemark) {
      return window.alert("New Quantity must be less than Alloted Quantity");
    }
    if (!reasonMySpecimenModal || reasonMySpecimenModal == "") {
      // if (selectedApprovalStatus == 2 && (!reasonMySpecimenModal || reasonMySpecimenModal == "")) {
      return window.alert("Remark is required");
    }
    try {
      setLoading(true);
      const payload = {
        id: selectedMySpecimenData?.id,
        is_accept: selectedApprovalStatus,
        action_remark: reasonMySpecimenModal,
        accepted_quantity: selectedMySpecimenData?.quantity,
        new_quantity_as_remark: newQuantityAsRemark
      }
      const results = await window.Platform.database.acceptedSpecimenToUser(payload)
      if (results?.success) {
        window.NotificationUtils.showSuccess(results?.message)
        setLoading(false);
        setMySpecimenModalOpen(false);
        setReasonMySpecimenModal("");
        setQuantityMySpecimenModal("");
        setSelectedMySpecimenData(null);
        setSelectedApprovalStatus(null);
        getMyAllotSpecimens()
      }
      else {
        setLoading(false);
        window.NotificationUtils.showError(results?.message)
      }

    }
    catch (err) {
      console.log(err)
      window.NotificationUtils.showError("Something Went Wrong!")
      setLoading(false)

    }
  };

  const getSpecimenItemsById = async (data) => {
    setLoading(true)
    try {
      setModalData()
      let payload = {
        specimenId: data
      }
      let results = await window.Platform.database.getSpecimenItemsById(payload);
      const jsonArrayWithId = results?.data?.map((obj, index) => ({ ...obj, id: index + 1 }));

      setModalData({ data: jsonArrayWithId, propSpecimenId: data })
      setModal(true)
      setLoading(false)
    }
    catch (error) {
      console.log(error)
      window.NotificationUtils.showError("Something Went Wrong!")
      setLoading(false)
    }
  }

  function allotSpecimen() {
    setSpecimenAllotmentModalOpen(true)
  }

  const onClose1 = () => {
    setSpecimenAllotmentModalOpen(false);
    getAllotSpecimens();
  };

  const handleOpenGetDeliveredSpecimenModal = (data) => {
    setGetDeliveredSpecimenModalData(data)
    setOpenGetDeliveredSpecimenViewModal(true)
  }
  const handleCloseGetDeliveredSpecimenViewModal = () => {
    setOpenGetDeliveredSpecimenViewModal(false);
    setGetDeliveredSpecimenModalData({})
  };

  const handleOpenGetMyAllotSpecimensColumnsModal = (data) => {
    setGetMyAllotSpecimensColumnsModalData(data)
    setOpenGetMyAllotSpecimensColumnsViewModal(true)
  }
  const handleCloseGetMyAllotSpecimensColumnsViewModal = () => {
    setOpenGetMyAllotSpecimensColumnsViewModal(false);
    setGetMyAllotSpecimensColumnsModalData({})
  };

  const handleOpenGetAllSpecimensAllotedColumnsModal = (data) => {
    setGetAllSpecimensAllotedColumnsColumnsModalData(data)
    setOpenGetAllSpecimensAllotedColumnsViewModal(true)
  }
  const handleCloseGetAllSpecimensAllotedColumnsViewModal = () => {
    setOpenGetAllSpecimensAllotedColumnsViewModal(false);
    setGetAllSpecimensAllotedColumnsColumnsModalData({})
  };

  const formatTimeStamp = (timestampFromDB) => {
    const options = {
      timeZone: 'Asia/Kolkata',
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      hour12: true,  // Use 12-hour clock
    };

    const formattedDate = new Date(timestampFromDB).toLocaleString('en-US', options);

    return formattedDate;
  };
  const getEmployeeColumns = () => {
    let result = [
      {
        field: "Name",
        headerName: "RM Name",
        width: 200,
        sortable: false,
        renderCell: (params) => {
          let name = params.row?.userName.toUpperCase() || "N/A"
          return (
            <Tooltip title={name || "N/A"}>
              <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name || "N/A"}</Typography>
            </Tooltip>
          )
        },
      },
      {
        field: "Remark",
        headerName: "Remark",
        sortable: false,
        width: 200,
        editable: false,
        renderCell: (params) => {
          let name = params.row?.remarks || "N/A"
          return (
            <Tooltip title={name || "N/A"}>
              <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name || "N/A"}</Typography>
            </Tooltip>
          )
        },
      },
      // {
      //   field: "SRNo",
      //   headerName: "SR No.",
      //   width: 150,
      //   sortable: false,
      //   renderCell: (params) => {
      //     let name = params.row.SRNo || "N/A"
      //     return (
      //       <Tooltip title={name || "N/A"}>
      //         <Typography variant="inherit" sx={{color:"black", fontSize:"12px", fontWeight:"500"}}>{name || "N/A"}</Typography>
      //       </Tooltip>
      //     )

      //   },
      // },
      {
        field: "Action Taken By",
        headerName: "Action Taken By",
        width: 200,
        sortable: false,
        renderCell: (params) => {
          let name = params.row?.actionByName || "N/A"
          return (
            <Tooltip title={name || "N/A"}>
              <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name || "N/A"}</Typography>
            </Tooltip>
          )
        },
      },
      {
        field: "StatusApprovalOrReject",
        headerName: "Status",
        width: 200,
        sortable: false,
        renderCell: (params) => {
          let name = params.row?.status == 0 ? "Pending" : params.row.status == 1 ? "Approved" : params.row.status == 2 ? "Rejected" : params.row.status == 3 ? "Partially Approved" : "N/A" || "N/A"
          return (
            <Tooltip title={name || "N/A"}>
              <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name || "N/A"}</Typography>
            </Tooltip>
          )
        },
      },
      {
        field: "SubmitedSpecimenDate",
        headerName: "Submited Date",
        width: 250,
        sortable: false,
        renderCell: (params) => {
          let rawDate = params.row?.createdAt;

          let name = "N/A";
                
          if (rawDate) {
            const d = new Date(rawDate);
            const day = String(d.getDate()).padStart(2, "0");
            const month = String(d.getMonth() + 1).padStart(2, "0"); // months are 0-based
            const year = d.getFullYear();
            name = `${day}-${month}-${year}`;
          }          
          return (
            <Tooltip title={name || "N/A"}>
              <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name || "N/A"}</Typography>
            </Tooltip>
          )
        },
      },

      {
        field: "Approve Order",
        headerName: "Actions",
        width: 130,
        filterable: false,
        headerAlign: 'center',
        sortable: false,
        editable: false,
        renderCell: (params) => {
          return (
            <Stack direction={"row"} spacing={0}>
              <Tooltip title="Click to view"><IconButton variant="extended" color="primary"
                onClick={(e) => {
                  e.stopPropagation();
                  getSpecimenItemsById(params?.row?.specimenId);
                }}
              >
                <RemoveRedEyeIcon />
              </IconButton></Tooltip>
            { accessModulesData && accessModulesData[0]?.is_download?.toLowerCase() != "no" &&  <Tooltip title="Click to approve Specimen"><IconButton disabled={params.row?.status === 1 || params.row?.status === 2} variant="extended" sx={{ color: "#008000" }} onClick={(e) => {
                e.stopPropagation();
                approveRejectOrder({ specimenId: params?.row?.specimenId, approvalStatus: "1", isDirectApproval: true });
              }} >
                <ThumbUpIcon />
              </IconButton></Tooltip>}
            </Stack>
          )
        },
      },
    ];
    return result
  }

  const getDeliveredSpecimen = () => {
    let result = [
      {
        field: "assignedTo1",
        headerName: "Assigned To",
        width: 180,
        sortable: false,
        renderCell: (params) => {
          let name = params.row?.user_name || "N/A"
          return (
            <Tooltip title={name || "N/A"}>
              <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name || "N/A"}</Typography>
            </Tooltip>
          )
        },
      },
      {
        field: "assignedRole1",
        headerName: "Role",
        width: 150,
        sortable: false,
        renderCell: (params) => {
          let name = params.row?.role_name?.toUpperCase() || "N/A"
          return (
            <Tooltip title={name || "N/A"}>
              <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name || "N/A"}</Typography>
            </Tooltip>
          )
        },
      },
      {
        field: "reporting_manager_name12",
        headerName: "Reporting Manager",
        width: 150,
        sortable: false,
        renderCell: (params) => {
          let name = params.row?.reporting_manager_name || "N/A";
          return (
            <Tooltip title={name || "N/A"}>
              <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name || "N/A"}</Typography>
            </Tooltip>
          )
        },
      },
      {
        field: "created_by_name1",
        headerName: "Assigned By",
        sortable: false,
        width: 180,
        editable: false,
        renderCell: (params) => {
          let name = params.row?.created_by_name || "N/A";
          return (
            <Tooltip title={name || "N/A"}>
              <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name || "N/A"}</Typography>
            </Tooltip>
          )
        },
      },
      {
        field: "nameSku121212",
        headerName: "Product Name",
        sortable: false,
        width: 180,
        editable: false,
        renderCell: (params) => {
          let name = params.row?.nameSku || "N/A";
          return (
            <Tooltip title={name || "N/A"}>
              <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name || "N/A"}</Typography>
            </Tooltip>
          )
        },
      },
      {
        field: "quantity12",
        headerName: "Quantity",
        width: 100,
        sortable: false,
        renderCell: (params) => {
          let name = params.row.quantity || "N/A";
          return (
            <Tooltip title={name || "N/A"}>
              <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name || "N/A"}</Typography>
            </Tooltip>
          )
        },
      },
      {
        field: "series_name12",
        headerName: "Series Name",
        width: 130,
        sortable: false,
        renderCell: (params) => {
          let name = params.row.series_name || "N/A";
          return (
            <Tooltip title={name || "N/A"}>
              <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name || "N/A"}</Typography>
            </Tooltip>
          )
        },
      },
      {
        field: "View",
        headerName: "View",
        minWidth: 100,
        filterable: false,
        sortable: false,
        renderCell: (params) => {
          return (
            <>
              <Tooltip>
                <span>
                  <Button
                    variant="contained"
                    size="small"
                    onClick={() => handleOpenGetDeliveredSpecimenModal(params.row)}
                    sx={{ minWidth: "80px" }}
                  >
                    {"View"}
                  </Button>
                </span>
              </Tooltip>
              <Modal open={openGetDeliveredSpecimenViewModal} onClose={handleCloseGetDeliveredSpecimenViewModal}>
                <Box
                  sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: "80%",
                    maxWidth: 900,
                    bgcolor: "white",
                    boxShadow: 24,
                    p: 4,
                    borderRadius: 2,
                    maxHeight: "90%",
                    overflowY: "auto",
                  }}
                >
                  <Typography variant="h6" component="h2" style={{ textAlign: "center" }} sx={{ color: "black", fontSize: "16px", fontWeight: "600" }}>
                    Expense Details
                  </Typography>
                  <IconButton onClick={() => setOpenGetDeliveredSpecimenViewModal(false)} style={{ position: "absolute", top: 10, right: 10 }}>
                    <CloseOutlined />
                  </IconButton>
                  {/* <hr style={{ width: "100%", color:"black", fontWeight:"800" }} /> */}
                  <hr style={{ width: "100%", border: "none", borderTop: "2px solid #222", margin: "16px 0" }} />
                  <div>
                    <div className="row mb-3 mt-1">
                      <div className="col-md-6">
                        <b style={{ color: "black", fontSize: "15px" }}> Assigned To : </b> <span style={{ color: "black", fontWeight: "500" }}> {getDeliveredSpecimenModalData?.user_name || "N/A"}</span>
                      </div>
                      <div className="col-md-6">
                        <b style={{ color: "black", fontSize: "15px" }}> Role : </b> <span style={{ color: "black", fontWeight: "500" }}> {getDeliveredSpecimenModalData?.role_name?.toUpperCase() || "N/A"}</span>
                      </div>
                    </div>

                    <div className="row mb-3 mt-1">
                      <div className="col-md-6">
                        <b style={{ color: "black", fontSize: "15px" }}> Reporting Manager : </b> <span style={{ color: "black", fontWeight: "500" }}> {getDeliveredSpecimenModalData?.reporting_manager_name || "N/A"}</span>
                      </div>
                      <div className="col-md-6">
                        <b style={{ color: "black", fontSize: "15px" }}> Assigne By : </b> <span style={{ color: "black", fontWeight: "500" }}> {getDeliveredSpecimenModalData?.created_by_name || "N/A"}</span>
                      </div>
                    </div>
                    <div className="row mb-3 mt-1">
                      <div className="col-md-6">
                        <b style={{ color: "black", fontSize: "15px" }}>Product Name : </b>
                        <span style={{ color: "black", fontWeight: "500" }}>  {getDeliveredSpecimenModalData?.nameSku || "N/A"}</span>
                      </div>
                      <div className="col-md-6">
                        <b style={{ color: "black", fontSize: "15px" }}>Board Name : </b>
                        <span style={{ color: "black", fontWeight: "500" }}>  {getDeliveredSpecimenModalData?.board_name || "N/A"}</span>
                      </div>

                    </div>

                    <div className="row mb-3 mt-1">
                      <div className="col-md-6">
                        <b style={{ color: "black", fontSize: "15px" }}> Class Name : </b>
                        <span style={{ color: "black", fontWeight: "500" }}> {getDeliveredSpecimenModalData?.class_name || 'N/A'}</span>
                      </div>
                      <div className="col-md-6">
                        <b style={{ color: "black", fontSize: "15px" }}> Medium Name : </b><span style={{ color: "black", fontWeight: "500" }}>  {getDeliveredSpecimenModalData?.medium_name || "N/A"}</span>
                      </div>

                    </div>
                    <div className="row mb-3 mt-1">
                      <div className="col-md-6">
                        <b style={{ color: "black", fontSize: "15px" }}> Qantity : </b> <span style={{ color: "black", fontWeight: "500" }}> {getDeliveredSpecimenModalData?.quantity || "N/A"}</span>
                      </div>
                      <div className="col-md-6">
                        <b style={{ color: "black", fontSize: "15px" }}> Series Name : </b><span style={{ color: "black", fontWeight: "500" }}>  {getDeliveredSpecimenModalData?.series_name || "N/A"}</span>
                      </div>

                    </div>
                    <div className="row mb-3 mt-1">
                      <div className="col-md-6">
                        <b style={{ color: "black", fontSize: "15px" }}> Subject : </b><span style={{ color: "black", fontWeight: "500" }}>  {getDeliveredSpecimenModalData?.subject_name || "N/A"}</span>
                      </div>
                    </div>
                  </div>
                  <Box mt={2} display="flex" justifyContent="flex-end">
                    <Button onClick={handleCloseGetDeliveredSpecimenViewModal} variant="contained" color="primary">
                      Close
                    </Button>
                  </Box>
                </Box>
              </Modal>
            </>
          );
        },
      },
    ];
    return result
  }

  const getMyAllotSpecimensColumns = () => {
    let result = [
      {
        field: "assignedTo1",
        headerName: "Assigned To",
        width: 180,
        sortable: false,
        renderCell: (params) => {
          let name = params.row?.user_name || "N/A"
          return (
            <Tooltip title={name || "N/A"}>
              <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name || "N/A"}</Typography>
            </Tooltip>
          )
        },
      },
      {
        field: "assignedRole1",
        headerName: "Role",
        width: 130,
        sortable: false,
        renderCell: (params) => {
          let name = params.row?.role_name?.toUpperCase() || "N/A"
          return (
            <Tooltip title={name || "N/A"}>
              <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name || "N/A"}</Typography>
            </Tooltip>
          )
        },
      },
      {
        field: "reporting_manager_name12",
        headerName: "Reporting Manager",
        width: 180,
        sortable: false,
        renderCell: (params) => {
          let name = params.row?.reporting_manager_name || "N/A";
          return (
            <Tooltip title={name || "N/A"}>
              <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name || "N/A"}</Typography>
            </Tooltip>
          )
        },
      },
      {
        field: "created_by_name1",
        headerName: "Assigned By",
        sortable: false,
        width: 180,
        editable: false,
        renderCell: (params) => {
          let name = params.row?.created_by_name || "N/A";
          return (
            <Tooltip title={name || "N/A"}>
              <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name || "N/A"}</Typography>
            </Tooltip>
          )
        },
      },
      {
        field: "nameSku121212",
        headerName: "Product Name",
        sortable: false,
        width: 180,
        editable: false,
        renderCell: (params) => {
          let name = params.row?.nameSku || "N/A";
          return (
            <Tooltip title={name || "N/A"}>
              <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name || "N/A"}</Typography>
            </Tooltip>
          )
        },
      },
      {
        field: "quantity12",
        headerName: "Quantity",
        width: 120,
        sortable: false,
        renderCell: (params) => {
          let name = params.row.quantity || "N/A";
          return (
            <Tooltip title={name || "N/A"}>
              <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name || "N/A"}</Typography>
            </Tooltip>
          )
        },
      },
      {
        field: "series_name12",
        headerName: "Series Name",
        width: 130,
        sortable: false,
        renderCell: (params) => {
          let name = params.row.series_name || "N/A";
          return (
            <Tooltip title={name || "N/A"}>
              <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name || "N/A"}</Typography>
            </Tooltip>
          )
        },
      },
      {
        field: "View",
        headerName: "View",
        minWidth: 100,
        filterable: false,
        sortable: false,
        renderCell: (params) => {
          return (
            <>
              <Tooltip>
                <span>
                  <Button
                    variant="contained"
                    size="small"
                    onClick={() => handleOpenGetMyAllotSpecimensColumnsModal(params.row)}
                    sx={{ minWidth: "80px" }}
                  >
                    {"View"}
                  </Button>
                </span>
              </Tooltip>
              <Modal open={openGetMyAllotSpecimensColumnsViewModal} onClose={handleCloseGetMyAllotSpecimensColumnsViewModal}>
                <Box
                  sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: "80%",
                    maxWidth: 900,
                    bgcolor: "white",
                    boxShadow: 24,
                    p: 4,
                    borderRadius: 2,
                    maxHeight: "90%",
                    overflowY: "auto",
                  }}
                >
                  <Typography variant="h6" component="h2" style={{ textAlign: "center" }} sx={{ color: "black", fontSize: "16px", fontWeight: "600" }}>
                    Expense Details
                  </Typography>
                  <IconButton onClick={() => setOpenGetMyAllotSpecimensColumnsViewModal(false)} style={{ position: "absolute", top: 10, right: 10 }}>
                    <CloseOutlined />
                  </IconButton>
                  {/* <hr style={{ width: "100%", color:"black", fontWeight:"800" }} /> */}
                  <hr style={{ width: "100%", border: "none", borderTop: "2px solid #222", margin: "16px 0" }} />
                  <div>
                    <div className="row mb-3 mt-1">
                      <div className="col-md-6">
                        <b style={{ color: "black", fontSize: "15px" }}> Assigned To : </b> <span style={{ color: "black", fontWeight: "500" }}> {getMyAllotSpecimensColumnsModalData?.user_name || "N/A"}</span>
                      </div>
                      <div className="col-md-6">
                        <b style={{ color: "black", fontSize: "15px" }}> Role : </b> <span style={{ color: "black", fontWeight: "500" }}> {getMyAllotSpecimensColumnsModalData?.role_name?.toUpperCase() || "N/A"}</span>
                      </div>
                    </div>

                    <div className="row mb-3 mt-1">
                      <div className="col-md-6">
                        <b style={{ color: "black", fontSize: "15px" }}> Reporting Manager : </b> <span style={{ color: "black", fontWeight: "500" }}> {getMyAllotSpecimensColumnsModalData?.reporting_manager_name || "N/A"}</span>
                      </div>
                      <div className="col-md-6">
                        <b style={{ color: "black", fontSize: "15px" }}> Assigne By : </b> <span style={{ color: "black", fontWeight: "500" }}> {getMyAllotSpecimensColumnsModalData?.created_by_name || "N/A"}</span>
                      </div>
                    </div>
                    <div className="row mb-3 mt-1">
                      <div className="col-md-6">
                        <b style={{ color: "black", fontSize: "15px" }}>Product Name : </b>
                        <span style={{ color: "black", fontWeight: "500" }}>  {getMyAllotSpecimensColumnsModalData?.nameSku || "N/A"}</span>
                      </div>
                      <div className="col-md-6">
                        <b style={{ color: "black", fontSize: "15px" }}>Board Name : </b>
                        <span style={{ color: "black", fontWeight: "500" }}>  {getMyAllotSpecimensColumnsModalData?.board_name || "N/A"}</span>
                      </div>

                    </div>

                    <div className="row mb-3 mt-1">
                      <div className="col-md-6">
                        <b style={{ color: "black", fontSize: "15px" }}> Class Name : </b>
                        <span style={{ color: "black", fontWeight: "500" }}> {getMyAllotSpecimensColumnsModalData?.class_name || 'N/A'}</span>
                      </div>
                      <div className="col-md-6">
                        <b style={{ color: "black", fontSize: "15px" }}> Medium Name : </b><span style={{ color: "black", fontWeight: "500" }}>  {getMyAllotSpecimensColumnsModalData?.medium_name || "N/A"}</span>
                      </div>

                    </div>
                    <div className="row mb-3 mt-1">
                      <div className="col-md-6">
                        <b style={{ color: "black", fontSize: "15px" }}> Qantity : </b> <span style={{ color: "black", fontWeight: "500" }}> {getMyAllotSpecimensColumnsModalData?.quantity || "N/A"}</span>
                      </div>
                      <div className="col-md-6">
                        <b style={{ color: "black", fontSize: "15px" }}> Series Name : </b><span style={{ color: "black", fontWeight: "500" }}>  {getMyAllotSpecimensColumnsModalData?.series_name || "N/A"}</span>
                      </div>

                    </div>
                    <div className="row mb-3 mt-1">
                      <div className="col-md-6">
                        <b style={{ color: "black", fontSize: "15px" }}> Subject : </b><span style={{ color: "black", fontWeight: "500" }}>  {getMyAllotSpecimensColumnsModalData?.subject_name || "N/A"}</span>
                      </div>
                    </div>
                  </div>
                  <Box mt={2} display="flex" justifyContent="flex-end">
                    <Button onClick={handleCloseGetMyAllotSpecimensColumnsViewModal} variant="contained" color="primary">
                      Close
                    </Button>
                  </Box>
                </Box>
              </Modal>
            </>
          );
        },
      },
      {
        field: "Actions221",
        headerName: "Actions",
        width: 150,
        filterable: false,
        // headerAlign: 'center',
        sortable: false,
        renderCell: (params) => {
          return (
            <Stack direction={"row"} spacing={0}>
              <Button
                variant="contained"
                color="success"
                disabled={params.row?.is_accept === 1 || params.row?.is_accept === 2}
                onClick={(e) => {
                  e.stopPropagation();
                  // approveMySpecimen({ allDataMySpecimen: params?.row, approvalStatus: "1" });
                  setSelectedMySpecimenData(params.row);
                  setSelectedApprovalStatus("1");
                  setMySpecimenModalOpen(true);

                }}>
                Accept
              </Button>
              {/* <Tooltip title="Accept Specimen">
                <IconButton
                  disabled={params.row?.is_accept === 1 || params.row?.is_accept === 2}
                  variant="extended"
                  sx={{ color: "#008000" }}
                  onClick={(e) => {
                    e.stopPropagation();
                    // approveMySpecimen({ allDataMySpecimen: params?.row, approvalStatus: "1" });
                    setSelectedMySpecimenData(params.row);
                    setSelectedApprovalStatus("1");
                    setMySpecimenModalOpen(true);

                  }}
                >
                  <ThumbUpIcon />
                </IconButton>
              </Tooltip> */}
              {/* <Tooltip title="Reject Specimen">
                <IconButton
                  disabled={params.row?.is_accept === 1 || params.row?.is_accept === 2}
                  variant="extended"
                  sx={{ color: "red" }}
                  onClick={(e) => {
                    e.stopPropagation();
                    // handleReject({ id: value, ownerId });
                    setSelectedMySpecimenData(params.row);
                    setSelectedApprovalStatus("2");
                    setMySpecimenModalOpen(true);
                  }}
                >
                  <ThumbDownIcon />
                </IconButton>
              </Tooltip> */}
            </Stack>
          )

        },
      },
    ];
    return result
  }


  const getAllSpecimensAllotedColumns = () => {
    let result = [
      {
        field: "assignedTo1",
        headerName: "Assigned To",
        width: 180,
        sortable: false,
        renderCell: (params) => {
          let name = params.row?.owner_name || "N/A"
          return (
            <Tooltip title={name || "N/A"}>
              <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name || "N/A"}</Typography>
            </Tooltip>
          )
        },
      },
      {
        field: "assignedRole1",
        headerName: "Role",
        width: 250,
        sortable: false,
        renderCell: (params) => {
          let name = params.row?.role_name?.toUpperCase() || "N/A"
          return (
            <Tooltip title={name || "N/A"}>
              <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name || "N/A"}</Typography>
            </Tooltip>
          )
        },
      },
      {
        field: "reporting_manager_name12",
        headerName: "Reporting Manager",
        width: 180,
        sortable: false,
        renderCell: (params) => {
          let name = params.row?.reporting_manager_name || "N/A";
          return (
            <Tooltip title={name || "N/A"}>
              <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name || "N/A"}</Typography>
            </Tooltip>
          )
        },
      },
      {
        field: "nameSku121212",
        headerName: "Product Name",
        sortable: false,
        width: 180,
        editable: false,
        renderCell: (params) => {
          let name = params.row?.nameSku || "N/A";
          return (
            <Tooltip title={name || "N/A"}>
              <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name || "N/A"}</Typography>
            </Tooltip>
          )
        },
      },
      {
        field: "quantity12",
        headerName: "Quantity",
        width: 120,
        sortable: false,
        renderCell: (params) => {
          let name = params.row.quantity || "N/A";
          return (
            <Tooltip title={name || "N/A"}>
              <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name || "N/A"}</Typography>
            </Tooltip>
          )
        },
      },
      {
        field: "series_name12",
        headerName: "Series Name",
        width: 130,
        sortable: false,
        renderCell: (params) => {
          let name = params.row.series_name || "N/A";
          return (
            <Tooltip title={name || "N/A"}>
              <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name || "N/A"}</Typography>
            </Tooltip>
          )
        },
      },
      {
        field: "View",
        headerName: "View",
        minWidth: 100,
        filterable: false,
        sortable: false,
        renderCell: (params) => {
          return (
            <>
              <Tooltip>
                <span>
                  <Button
                    variant="contained"
                    size="small"
                    onClick={() => handleOpenGetAllSpecimensAllotedColumnsModal(params.row)}
                    sx={{ minWidth: "80px" }}
                  >
                    {"View"}
                  </Button>
                </span>
              </Tooltip>
              <Modal open={openGetAllSpecimensAllotedColumnsViewModal} onClose={handleCloseGetAllSpecimensAllotedColumnsViewModal}>
                <Box
                  sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: "80%",
                    maxWidth: 900,
                    bgcolor: "white",
                    boxShadow: 24,
                    p: 4,
                    borderRadius: 2,
                    maxHeight: "90%",
                    overflowY: "auto",
                  }}
                >
                  <Typography variant="h6" component="h2" style={{ textAlign: "center" }} sx={{ color: "black", fontSize: "16px", fontWeight: "600" }}>
                    Expense Details
                  </Typography>
                  <IconButton onClick={() => setOpenGetAllSpecimensAllotedColumnsViewModal(false)} style={{ position: "absolute", top: 10, right: 10 }}>
                    <CloseOutlined />
                  </IconButton>
                  {/* <hr style={{ width: "100%", color:"black", fontWeight:"800" }} /> */}
                  <hr style={{ width: "100%", border: "none", borderTop: "2px solid #222", margin: "16px 0" }} />
                  <div>
                    <div className="row mb-3 mt-1">
                      <div className="col-md-6">
                        <b style={{ color: "black", fontSize: "15px" }}> Assigned To : </b> <span style={{ color: "black", fontWeight: "500" }}> {getAllSpecimensAllotedColumnsModalData?.owner_name || "N/A"}</span>
                      </div>
                      <div className="col-md-6">
                        <b style={{ color: "black", fontSize: "15px" }}> Role : </b> <span style={{ color: "black", fontWeight: "500" }}> {getAllSpecimensAllotedColumnsModalData?.role_name?.toUpperCase() || "N/A"}</span>
                      </div>
                    </div>

                    <div className="row mb-3 mt-1">
                      <div className="col-md-6">
                        <b style={{ color: "black", fontSize: "15px" }}> Reporting Manager : </b> <span style={{ color: "black", fontWeight: "500" }}> {getAllSpecimensAllotedColumnsModalData?.reporting_manager_name || "N/A"}</span>
                      </div>
                      <div className="col-md-6">
                        <b style={{ color: "black", fontSize: "15px" }}>Product Name : </b>
                        <span style={{ color: "black", fontWeight: "500" }}>  {getAllSpecimensAllotedColumnsModalData?.nameSku || "N/A"}</span>
                      </div>
                    </div>
                    <div className="row mb-3 mt-1">

                      <div className="col-md-6">
                        <b style={{ color: "black", fontSize: "15px" }}>Board Name : </b>
                        <span style={{ color: "black", fontWeight: "500" }}>  {getAllSpecimensAllotedColumnsModalData?.board_name || "N/A"}</span>
                      </div>
                      <div className="col-md-6">
                        <b style={{ color: "black", fontSize: "15px" }}> Class Name : </b>
                        <span style={{ color: "black", fontWeight: "500" }}> {getAllSpecimensAllotedColumnsModalData?.class_name || 'N/A'}</span>
                      </div>
                    </div>

                    <div className="row mb-3 mt-1">

                      <div className="col-md-6">
                        <b style={{ color: "black", fontSize: "15px" }}> Medium Name : </b><span style={{ color: "black", fontWeight: "500" }}>  {getAllSpecimensAllotedColumnsModalData?.medium_name || "N/A"}</span>
                      </div>
                      <div className="col-md-6">
                        <b style={{ color: "black", fontSize: "15px" }}> Qantity : </b> <span style={{ color: "black", fontWeight: "500" }}> {getAllSpecimensAllotedColumnsModalData?.quantity || "N/A"}</span>
                      </div>
                    </div>
                    <div className="row mb-3 mt-1">

                      <div className="col-md-6">
                        <b style={{ color: "black", fontSize: "15px" }}> Series Name : </b><span style={{ color: "black", fontWeight: "500" }}>  {getAllSpecimensAllotedColumnsModalData?.series_name || "N/A"}</span>
                      </div>
                      <div className="col-md-6">
                        <b style={{ color: "black", fontSize: "15px" }}> Subject : </b><span style={{ color: "black", fontWeight: "500" }}>  {getAllSpecimensAllotedColumnsModalData?.subject_name || "N/A"}</span>
                      </div>
                    </div>
                  </div>
                  <Box mt={2} display="flex" justifyContent="flex-end">
                    <Button onClick={handleCloseGetAllSpecimensAllotedColumnsViewModal} variant="contained" color="primary">
                      Close
                    </Button>
                  </Box>
                </Box>
              </Modal>
            </>
          );
        },
      },
    ];
    return result
  }

  function CustomToolbar() {
    return (
      <>
        <GridToolbarContainer>
          {selectedTab == 0 && <div>
            <Button
              onClick={() => { setHasSearched(true); setNewOrderStatus("") }}
              style={{ backgroundColor: newOrderStatus === "" ? "#8787f470" : "white", color: newOrderStatus === "" ? "#000000" : "black", }}>
              All
            </Button>
            <Button
              onClick={() => { setHasSearched(true); setNewOrderStatus(0) }}
              style={{ backgroundColor: newOrderStatus === 0 ? "#fe9f13" : "white", color: newOrderStatus === 0 ? "white" : "black", }}>
              Pending
            </Button>
            <Button
              onClick={() => { setHasSearched(true); setNewOrderStatus(1) }}
              style={{ backgroundColor: newOrderStatus === 1 ? "green" : "white", color: newOrderStatus === 1 ? "white" : "black", }}>
              Approved
            </Button>
            <Button
              onClick={() => { setHasSearched(true); setNewOrderStatus(2) }}
              style={{ backgroundColor: newOrderStatus === 2 ? "red" : "white", color: newOrderStatus === 2 ? "white" : "black", }}>
              Rejected
            </Button>
            <Button
              onClick={() => { setHasSearched(true); setNewOrderStatus(3) }}
              style={{ backgroundColor: newOrderStatus === 3 ? "#cddc39" : "white", color: newOrderStatus === 3 ? "black" : "black", fontWeight: "500", }}>
              Partially Approved
            </Button>
          </div>}
          <Typography variant="body1" className="ml-4" sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>Select Page Size:&nbsp; </Typography>

          <Select
            value={paginationModel.pageSize}
            variant="outlined"
            size="small"
            onChange={(e) => { { setHasSearched(true); setPaginationModel({ ...paginationModel, pageSize: e.target.value }) } }}
            sx={{ width: 90, fontSize: 13, fontWeight: "500" }}
          >
            {[10, 20, 30, 50, 100].map((role) => (
              <MenuItem key={role} value={role} sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>{role}</MenuItem>
            ))}
          </Select>
          {selectedTab == 1 && <Button style={{ display: "flex", justifyContent: "end", alignItems: "end", position: "absolute", right: "10px" }}
            variant="contained"
            color="primary"
            onClick={() => { allotSpecimen() }}
          >
            Specimen Distribute
          </Button>}
        </GridToolbarContainer>
      </>
    );
  }

  const renderContent = () => {
    return (
      <Box sx={{ height: "100%", width: "100%" }}>
        <DataGridContainer style={{ height: accessChanges.length === 0 ? '200px' : 'auto' }}>
          <DataGrid
            // className="payrollGrid"
            // //   checkboxSelection={true}
            // density="compact"
            // rows={accessChanges || []}
            // columns={getEmployeeColumns()}
            // sx={{ color: "black", fontSize: "14px", fontWeight: "400" }}
            // rowHeight={60}
            // disableDensitySelector
            // disableSelectionOnClick
            // disableRowSelectionOnClick
            // // autoPageSize
            // rowCount={rowCount}
            // initialState={{
            //   pagination: {
            //     paginationModel: {
            //       pageSize: 10,
            //     },
            //   },
            // }}
            // pageSizeOptions={[10]}
              className="payrollGrid"
          density="compact"
          rows={accessChanges || []}
          columns={getEmployeeColumns()}
          sx={{ color: "black", fontSize: "14px", fontWeight: "600" }}
          disableSelectionOnClick
          disableRowSelectionOnClick
          rowHeight={60}
          disableDensitySelector
          pageSizeOptions={[10]}
          filterMode="server"
          rowCount={rowCount}
          paginationModel={paginationModel}
          paginationMode="server"
          onPaginationModelChange={setPaginationModel}
          getRowId={(row, index) => `${row.specimenId}-${row.createdAt}-${row?.updatedAt}-${row?.ownerId}` || index}
            components={{
              Toolbar: CustomToolbar,
            }}
          />
        </DataGridContainer>
      </Box>
    );
  };

  const renderContent1 = () => {
    return (
      <Box sx={{ height: "100%", width: "100%" }}>
        <DataGridContainer style={{ height: deliveredSpecimens.length === 0 ? '200px' : 'auto' }}>
          <DataGrid
            // className="payrollGrid"
            // //   checkboxSelection={true}
            // density="compact"
            // rows={deliveredSpecimens || []}
            // columns={getDeliveredSpecimen()}
            // sx={{ color: "black", fontSize: "14px", fontWeight: "400" }}
            // rowHeight={60}
            // disableDensitySelector
            // disableSelectionOnClick
            // disableRowSelectionOnClick
            // // autoPageSize
            // rowCount={rowCount}
            // initialState={{
            //   pagination: {
            //     paginationModel: {
            //       pageSize: 10,
            //     },
            //   },
            // }}
            // pageSizeOptions={[10]}
                  className="payrollGrid"
          density="compact"
          rows={deliveredSpecimens || []}
          columns={getDeliveredSpecimen()}
          sx={{ color: "black", fontSize: "14px", fontWeight: "600" }}
          disableSelectionOnClick
          disableRowSelectionOnClick
          rowHeight={60}
          disableDensitySelector
          pageSizeOptions={[10]}
          filterMode="server"
          rowCount={rowCount}
          paginationModel={paginationModel}
          paginationMode="server"
          onPaginationModelChange={setPaginationModel}
          getRowId={(row, index) => `${row.id}-${row.createdAt}-${row?.updatedAt}-${row?.userId}-${index}` || index}
            components={{
              Toolbar: CustomToolbar,
            }}
          />
        </DataGridContainer>
      </Box>
    );
  };

  const renderContent2 = () => {
    return (
      <Box sx={{ height: "100%", width: "100%" }}>
        <DataGridContainer style={{ height: myAllotedSpecimeArr.length === 0 ? '200px' : 'auto' }}>
          <DataGrid
            className="payrollGrid"
            //   checkboxSelection={true}
            density="compact"
            rows={myAllotedSpecimeArr || []}
            columns={getMyAllotSpecimensColumns()}
            sx={{ color: "black", fontSize: "14px", fontWeight: "400" }}
            rowHeight={60}
            disableDensitySelector
            disableSelectionOnClick
            disableRowSelectionOnClick
            // autoPageSize
            rowCount={rowCount}
            initialState={{
              pagination: {
                paginationModel: {
                  pageSize: 10,
                },
              },
            }}
            pageSizeOptions={[10]}
            components={{
              Toolbar: CustomToolbar,
            }}
          />
        </DataGridContainer>
      </Box>
    );
  };

  const renderContent3 = () => {
    return (
      <Box sx={{ height: "100%", width: "100%" }}>
        <DataGridContainer style={{ height: allSpecimensAllotedArr3.length === 0 ? '200px' : 'auto' }}>
          <DataGrid
            // className="payrollGrid"
            // density="compact"
            // rows={allSpecimensAllotedArr3 || []}
            // columns={getAllSpecimensAllotedColumns()}
            // sx={{ color: "black", fontSize: "14px", fontWeight: "400" }}
            // rowHeight={60}
            // disableDensitySelector
            // disableSelectionOnClick
            // disableRowSelectionOnClick
            // rowCount={rowCount}
            // initialState={{
            //   pagination: {
            //     paginationModel: {
            //       pageSize: 10,
            //     },
            //   },
            // }}
            // pageSizeOptions={[10]}
                  className="payrollGrid"
          density="compact"
          rows={allSpecimensAllotedArr3 || []}
          columns={getAllSpecimensAllotedColumns()}
          sx={{ color: "black", fontSize: "14px", fontWeight: "600" }}
          disableSelectionOnClick
          disableRowSelectionOnClick
          rowHeight={60}
          disableDensitySelector
          pageSizeOptions={[10]}
          filterMode="server"
          rowCount={rowCount}
          paginationModel={paginationModel}
          paginationMode="server"
          onPaginationModelChange={setPaginationModel}
          getRowId={(row, index) => `${row.allottedSpecimenId}-${row.createdAt}-${row?.updatedAt}-${row?.ownerId}-${index}` || index}
            components={{
              Toolbar: CustomToolbar,
            }}
          />
        </DataGridContainer>
      </Box>
    );
  };

  const handleEdit = (data) => {
    setEditModal(true)
    setDataModal(data)
  }

  const exportSpecimen = async () => {
    setLoading(true);
    try {
      let data = {
        status: newOrderStatus,
        ownerId: rm,
        asm: userData?.role == 'asm' ? userData?.id : asm,
        rsm: userData?.role == 'rsm' ? userData?.id : rsm,
      }
      let result = await window.Platform.database.exportData("Specimen/downloadSpecimenExcel",
        data
      )
      const blob = new Blob([result.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const now = new Date();
      const formattedDate = `${now.getDate().toString().padStart(2, '0')}-${(now.getMonth() + 1).toString().padStart(2, '0')}-${now.getFullYear()}`;
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `SpecimenReport_${formattedDate}.xlsx`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Export error:", error);
    }
  }
    const downloadAllotSpecimensExcel = async () => {
    setLoading(true);
    try {
      let data = {
        status: newOrderStatus,
        ownerId: rm,
        asm: userData?.role == 'asm' ? userData?.id : asm,
        rsm: userData?.role == 'rsm' ? userData?.id : rsm,
      }
      let result = await window.Platform.database.exportData("Specimen/downloadAllotSpecimensExcel",
        data
      )
      const blob = new Blob([result.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const now = new Date();
      const formattedDate = `${now.getDate().toString().padStart(2, '0')}-${(now.getMonth() + 1).toString().padStart(2, '0')}-${now.getFullYear()}`;
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `Distributed_Specimen_${formattedDate}.xlsx`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Export error:", error);
    }
  }

  return (
    <>

      <StaffEditorPageContainer>
        {loading && <OpaqueLoading />}
        <HeaderContainer>
          <div className="container-fluid">
            <Paper elevation={3}
              sx={{
                p: 2,
                mb: 2,
                width: '100%',        // takes full width of parent
                // maxWidth: '1000px',   // optional: control max width
                mx: 'auto',
                backgroundColor: "#ebf0fa"          // center it horizontally
              }}>
              <div className="row mb-1 align-items-end">
                {userData?.role.includes('admin') && (
                  <div className="col-md-3">
                    <FormControl fullWidth size="small">
                      <InputLabel sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>Select HO </InputLabel>
                      <Select label="Select HO" value={rsm} size="small" onChange={(e) => { setRsm(e.target.value); getUsers('rsm', e.target.value); setAsm(""); setRm(""); }} sx={{ width: '100%', fontSize: 13, fontWeight: "500" }}>
                        <MenuItem value="" sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>All</MenuItem>
                        {rsms.map((role) => (<MenuItem key={role} value={role.id} sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>{role.name} - {role.username}</MenuItem>))}
                      </Select>
                    </FormControl>
                  </div>)}
                {userData?.role !== 'asm' && (
                  <div className="col-md-3">
                    <FormControl fullWidth size="small">
                      <InputLabel sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>Select ARM </InputLabel>
                      <Select label="Select ARM" value={asm} size="small" onChange={(e) => { setAsm(e.target.value); getUsers('asm', e.target.value); setRm(""); }} sx={{ width: '100%', fontSize: 13, fontWeight: "500" }}>
                        <MenuItem value="" sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>All</MenuItem>
                        {asms.map((role) => (<MenuItem key={role} value={role.id} sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>{role.name} - {role.username}</MenuItem>))}
                      </Select>
                    </FormControl>
                  </div>)}
                <div className="col-md-2">
                  <FormControl fullWidth size="small">
                    <InputLabel sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>Select RM </InputLabel>
                    <Select label="Select RM" value={rm} size="small" onChange={(e) => { setRm(e.target.value); getUsers('rm', e.target.value) }} sx={{ width: '100%', fontSize: 13, fontWeight: "500" }}>
                      <MenuItem value="" sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>All</MenuItem>
                      {rms.map((role) => (<MenuItem key={role} value={role.id} sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>{role.name} - {role.username}</MenuItem>))}
                    </Select>
                  </FormControl>
                </div>
                <div className="col-md-2">
                  <Button variant="contained" color="primary" startIcon={<img src={searchIcon} alt="icon" height={"21"} width={"21"} />} fullWidth sx={{ fontSize: '14px', borderRadius: '10px' }} onClick={() => { setHasSearched(true); selectedTab == 0 ? getSpecimen() : selectedTab == 1 ? getAllotSpecimens() : selectedTab == 2 ? getMyAllotSpecimens() : getAllSpecimensAlloted() }}>
                    Find
                  </Button>
                </div>
                {  accessModulesData && accessModulesData[0]?.is_download?.toLowerCase() != "no" &&  (selectedTab == 0 ? <div className="col-md-2">
                  <Button variant="contained" color="success" startIcon={<FileDownloadIcon />} fullWidth sx={{ fontSize: '13px', borderRadius: '10px' }} onClick={() => exportSpecimen()}>
                    Download
                  </Button>
                </div>
                : 
                selectedTab == 1 ? <div className="col-md-2">
                  <Button variant="contained" color="success" startIcon={<FileDownloadIcon />} fullWidth sx={{ fontSize: '13px', borderRadius: '10px' }} onClick={() => downloadAllotSpecimensExcel()}>
                    Download
                  </Button>
                </div>
                : "")
                }
              </div>
            </Paper>
           <div className="d-flex justify-content-end ">
            <Button
              variant="contained"
              color="info"
              onClick={() => navigate("/allotedSpecimen")}
              sx={{ mr: 1, borderRadius: "10px" }}
            >
               Uploaded Specimen  
            </Button>
              {selectedTab === 0 && (
            <Button
              variant="contained"
              color="primary"
              onClick={() => setBulk(true)}
              sx={{ mr: 1, borderRadius: "10px" }}
            >
              <DriveFolderUploadIcon sx={{ mr: 1 }} />
              Bulk Upload
            </Button>
          )}
           </div>
          </div>
        </HeaderContainer>
        <TableContainer>
          {/* {renderContent()} */}
          <TabsContainer>
            <StyledTabs
              value={selectedTab}
              onChange={(event, value) => handleTabChange(value)}
              variant="fullWidth"
              indicatorColor="none"
            >
              <StyledTab label="Specimen Requests"  sx={{ fontSize: "15px", color: "#000", fontWeight:"600", backgroundColor: selectedTab == 0 ? "#fff" : "#e6e3e3de " }} />
              <StyledTab label="Specimen Distributed"  sx={{ fontSize: "15px", color: "#000", fontWeight:"600", backgroundColor: selectedTab == 1 ? "#fff" : "#e6e3e3de " }} />
              {userData && userData?.role == "asm" && <StyledTab label="Alloted Specimen Req"  sx={{ fontSize: "15px", color: "#000", fontWeight:"600", backgroundColor: selectedTab == 2 ? "#fff" : "#e6e3e3de " }} />}
              {userData && userData?.role == "asm" && <StyledTab label="My Specimen"  sx={{ fontSize: "15px", color: "#000", fontWeight:"600", backgroundColor: selectedTab == 3 ? "#fff" : "#e6e3e3de " }} />}
            </StyledTabs>

            {selectedTab == 0 ? renderContent() : selectedTab == 1 ? renderContent1() : selectedTab == 2 ? renderContent2() : renderContent3()}
          </TabsContainer>
        </TableContainer>
      </StaffEditorPageContainer>
      {
        visitModal &&
        <SpecimenModal
          onClose={() => setVisitModal(false)}
          loading={loading}
          fetchData={() => getSpecimen()}
          status={true}
        />
      }
      {
        editModal &&
        <SpecimenModal
          onClose={() => setEditModal(false)}
          // initialData={regexes.filter(rx => rx.id === showEditFormModal)[0]}
          loading={loading}
          fetchData={() => getSpecimen()}
          status={false}
          propData={dataModal}
        />
      }
      {bulk && 
      <BulkUploadSpecimenByAdmin 
      onClose={() => setBulk(false)} 
      // fetchData={() => getSpecimen()} 
      />

      }

      <Dialog open={openDialog} onClose={() => setOpenDialog(false)} fullWidth>
        <DialogTitle>Reject Specimen</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label="Remark"
            type="text"
            fullWidth
            variant="outlined"
            value={reason}
            onChange={(e) => setReason(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDialog(false)} color="primary">
            Cancel
          </Button>
          <Button onClick={handleConfirmReject} color="primary">
            OK
          </Button>
        </DialogActions>
      </Dialog>
      {/* asas */}

      <Dialog open={mySpecimenModalOpen} onClose={() => setMySpecimenModalOpen(false)} fullWidth>
        <DialogTitle>{selectedApprovalStatus == 1 ? "Approve Specimen" : "Reject Specimen"}</DialogTitle>
        <DialogContent>
          <TextField
            disabled
            margin="dense"
            label="Quantity"
            type="text"
            fullWidth
            variant="outlined"
            value={selectedMySpecimenData?.quantity}
          // onChange={(e) => setQuantityMySpecimenModal()}
          />
          <TextField
            margin="dense"
            label="Accepted Quantity"
            type="text"
            fullWidth
            variant="outlined"
            value={newQuantityAsRemark}
            onChange={(e) => setNewQuantityAsRemark(e.target.value)}
          />
          <TextField
            margin="dense"
            label="Remark"
            type="text"
            fullWidth
            variant="outlined"
            value={reasonMySpecimenModal}
            onChange={(e) => setReasonMySpecimenModal(e.target.value)}
            required={selectedApprovalStatus == 2 ? true : false}
          />

        </DialogContent>
        <DialogActions>
          <Button onClick={() => { setMySpecimenModalOpen(false); setReasonMySpecimenModal(""); setQuantityMySpecimenModal(null); setSelectedMySpecimenData(null); setSelectedApprovalStatus(null); setNewQuantityAsRemark("") }} color="primary">
            Cancel
          </Button>
          <Button onClick={() => handleOkMySpecimen()} color="primary">
            OK
          </Button>
        </DialogActions>
      </Dialog>


      {
        modal && <SpecimenLineItemsModal
          onCancel={() => { setModal(false); getSpecimen(); }}
          getSpecimenItemsById={getSpecimenItemsById}
          data={modalData}
          specimenId={modalData?.propSpecimenId}

        //  onCancel={() => { setModal(false); fetchOrder(); }}
        // loading={loading}
        // data={modalData}
        // routeId={modalData?.id}
        // routeDate={modalData?.date}
        // ownerId={modalData?.ownerId}
        // getRouteplanById={getRouteplanById}
        />
      }
      {specimenAllotmentModalOpen && (
        <SpecimenAllotmentModal
          onClose1={onClose1}
        />
      )}
    </>
  );
}
